import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemIntegrity,
} from "~utils/moduleIntegrity";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    const messages: IntegrityStatus = [];

    if (!items?.length || items.length < 2) {
        messages.push("Requires 2 stories");
    }
    const primaryStoryErrors = checkItemIntegrity(items?.[0] || null, [
        "headline",
    ]).map((message) => `First Story: ${message}`);

    messages.push(...primaryStoryErrors);

    const secondStoryErrors = checkItemIntegrity(items?.[1] || null, [
        "headline",
    ]).map((message) => `Second Story: ${message}`);

    // has vertical video in right element
    const isVerticalVideoHeadline = items?.[1]?.media?.verticalVideo;

    if (isVerticalVideoHeadline) {
        // vertical video is only allowed as left content
        messages.push(
            "Second Story: vertical video is only allowed in first story"
        );
    }

    messages.push(...secondStoryErrors);

    return messages;
}
